import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RaceEntryComponent } from './race-entry/race-entry.component';
import { AuthGuard } from '../../services/auth-guard.service';

const routes: Routes = [
  {path:'raceEntry',
   component:RaceEntryComponent,
   canActivate:[AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RaceEntryRoutingModule { }
